module.exports = __webpack_public_path__ + "img/Humanist.2efa2b10.png";